import request from '@/router/axios';
const urlPrefix = '/cus'

//分页查询雇员列表
export function getEmpList(obj) {
  return request({
    url: urlPrefix + '/emp/empinfo/emplist',
    method: 'post',
    data: obj,
  });
}

// 根据雇员id查询雇员信息
export function getEmpInfoById(obj) {
  return request({
    url: urlPrefix + '/emp/empinfo/empinfobyid',
    method: 'get',
    params: obj,
  });
}

//分页查询雇员列表report/averageWage
export function getEmpListOfSelect(obj) {
  return request({
    url: 'sys/emp/dataReady/personSelect',
    method: 'post',
    data: obj,
  });
}

